export const extracurricularData = [
  {
        id: 'felicis-fellow',
        title: 'AI Engineering Fellow',
        date: 'Jun 2026',
        organization: 'Felicis',
        image: '/images/extracurriculars/felicis.jpg',
        description: 'Connecting with Felicis partners and founders on how to become a successful entrepreneur. Located in San Francisco.',
        link: 'https://www.felicis.com/fellows'
  },
  {
    id: 'pareto-fellow',
    title: 'Engineering Fellow',
    date: 'Jan 2026 - Present',
    organization: 'Pareto',
    image: '/images/extracurriculars/pareto.png',
    description: 'Connecting with VCs and startup founders across the Europe and North America. Located in Paris and New York City.',
    link: 'http://paretofellowship.com/'
  },
  {
    id: 'kp-fellow',
    title: 'Engineering Fellow',
    date: 'May 2025 - Aug 2025',
    organization: 'Kleiner Perkins',
    image: '/images/extracurriculars/kpfellow.png',
    description: 'Connecting with VCs and startup founders in the SF Bay Area. Selected as 1 of 30 fellows from 5000+ applicants.',
    link: 'https://www.kleinerperkins.com/fellows/'
  },
  {
    id: 'wics-co-chair',
    title: 'Co-Chair',
    date: 'Aug 2025 - Dec 2025',
    organization: 'University of Waterloo WiCS',
    image: '/images/extracurriculars/wics.png',
    description: 'Responsible for planning and promoting Women in Computer Science (WiCS) events at the University of Waterloo.',
    link: 'https://wics.uwaterloo.ca/'
  },
  {
    id: 'netflix-formation',
    title: 'Software Engineer Fellow',
    date: 'May 2025 - Dec 2025',
    organization: 'Netflix x Formation',
    image: '/images/extracurriculars/netflix.png',
    description: 'Receiving personalized DSA and system design mentorship from senior Netflix engineers. Selected as 1 of 40 fellows from 1200+ applicants.',
    link: 'https://formation.dev/partners/netflix'
  },
  {
    id: 'htn-sponsorship',
    title: 'Sponsorship Coordinator',
    date: 'Mar 2025 - Sept 2025',
    organization: 'Hack the North',
    image: '/images/extracurriculars/htn.png',
    description: 'Raising $XXX XXX and building corporate relationships for Canada\'s largest hackathon.',
    link: 'https://hackthenorth.com/'
  },
  {
    id: 'wics-publicity',
    title: 'Director of Publicity',
    date: 'Sept 2024 - Apr 2025',
    organization: 'University of Waterloo WiCS',
    image: '/images/extracurriculars/wics.png',
    description: 'Responsible for planning and promoting Women in Computer Science (WiCS) events at the University of Waterloo.',
    link: 'https://wics.uwaterloo.ca/'
  },
  {
    id: 'badminton-coach',
    title: 'NCCP Certified Badminton Coach',
    date: 'Sept 2019 - Aug 2023',
    organization: 'Soong Badminton Academy',
    image: '/images/extracurriculars/sba.png',
    description: 'Mentored 600+ athletes of all ages and playing levels through error detection and on-court demonstrations.',
    link: 'https://www.soong.ca/'
  },
  {
    id: 'piano-teacher',
    title: 'Piano Teacher',
    date: 'Sept 2021 - Aug 2023',
    organization: "Janet's Music School",
    image: '/images/extracurriculars/piano.png',
    description: 'Taught 10+ students by introducing theoretical and practical concepts to develop effective hand positioning, pedal use, and sight reading.',
    link: 'https://janetsmusic.com/'
  },
  {
    id: 'line-judge',
    title: 'Line Judge',
    date: 'Sept 2022 - Aug 2023',
    organization: 'BWF Para-badminton',
    image: '/images/extracurriculars/para.png',
    description: 'Line judged for 100+ para-badminton international athletes by following official BWF etiquette and promoting sportsmanship.',
    link: 'https://sirc.ca/events/events-conferences/2023-yonex-canada-para-badminton-intnernational/'
  },
  {
    id: 'tournament-coordinator',
    title: 'Tournament Coordinator',
    date: 'Sept 2022 - Oct 2022',
    organization: 'Soong Badminton Academy',
    image: '/images/extracurriculars/tournie.png',
    description: 'Led the organization of a regional Ottawa tournament hosting 200+ badminton athletes under the mentorship of Dominic Soong and Janet Hugli.',
    link: 'https://photos.app.goo.gl/vkzpzvs3k5aZfCfC8'
  }
];
